import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGritStatics} from "../TrueGritStatics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

/**
 * Created by Jerker Nord on 2021-09-21.
 */

export class TrueGritSymbolBoxExplosionView extends PIXI.Container implements StageLayer{

    constructor() {
        super();
        this.name = "TrueGritSymbolBoxExplosionView";
        this.init();
    }

    private init() {
        this.onResize();
    }

    onResize():void {
        this.position = TrueGritStatics.SYMBOL_BOX_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }
}